import React, { Component } from 'react'
import { Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { ComponentImage } from '../FunctionalDiagrams/Image'
import ModalFullScreen from './Modal/ModalFullScreen'
import { injectIntl, FormattedMessage } from 'react-intl'

class ConnectorViewModal extends Component {
  constructor(props) {
    super(props)
    this.header = this.header.bind(this)
    this.content = this.content.bind(this)
  }

  header() {
    return (
      <Button icon={<ArrowLeftOutlined />} onClick={this.props.onClose}>
        <FormattedMessage id="generic.back" />
      </Button>
    )
  }

  content() {
    return (
      <ComponentImage
        fileName={this.props.imageUrl}
        pins={this.props.pins}
        theme={this.props.theme}
        showSideIcon
      />
    )
  }

  render() {
    return (
      <ModalFullScreen
        HeaderProp={this.header}
        ContentProp={this.content}
        isOpen={this.props.isOpen}
        dataTestIdContainer={'connector-view-modal'}
        dataTestIdHeader={'connector-view-modal-header'}
        dataTestIdContent={'connector-view-modal-content'}
      />
    )
  }
}

export default injectIntl(ConnectorViewModal)
